import axios from "axios";
import i18n from "../../../i18n";

// Constants
const SET_DASHBOARD_DATA = "SET_DASHBOARD_DATA";
const RESET_STATE = "RESET_STATE";

// Acessors
const getDashboardDefinition = (state) => state?.dashboardDefinition;

// Default state
const initialState = {
  data: null,
};

export const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_DASHBOARD_DATA:
      const { data } = action;
      return {
        ...data[0],
        dashboardDefinition: JSON.parse(data[0]["dashboardDefinition"]),
      };
    default:
      return state;
  }
};

const fetchDashboardData = (type) => (dispatch) =>
  axios
    .get(`/api/dashboard/getdashboards?type=${type}`)
    .then(({ data }) => {
      dispatch({
        type: SET_DASHBOARD_DATA,
        data: data,
      });
    })
    .catch(() => {
      return Promise.reject(i18n.t("errorText.dashboard.get"));
    });

export const resetState = () => (dispatch) => {
  dispatch({ type: RESET_STATE });
};

export const mapStateToProps = (state) => {
  return {
    dashboardDefinition: getDashboardDefinition(state),
  };
};

export const mapDispatchToProps = {
  fetchDashboardData,
  resetState,
};
